import type { ReactNode } from "react"

interface PageProps {
  children: ReactNode
  isLocked?: boolean
  className?: string
}

export function Page({ children, isLocked = false, className = '' }: PageProps) {
  // Locked content (居中显示，用于锁定页面)
  if (isLocked) {
    return (
      <div className="flex-1 flex flex-col bg-bgb">
        {children}
      </div>
    )
  }

  // Normal content (统一的内容容器样式)
  const hasSpacingOverride = className.includes('space-y-') || className.includes('gap-');
  const spacingClass = hasSpacingOverride ? '' : 'space-y-6';

  return (
    <div className={`w-full px-4 lg:px-0 py-6 ${spacingClass} ${className}`}>
      {children}
    </div>
  )
}